import { cn } from 'noddi-ui-common';
import type { FilterControl } from '../../../../../types/filterControl';
import { NoddiSeparator } from '../../../../Other/NoddiSeparator';

interface FilterSkeletonProps {
  control: FilterControl;
  index: number;
  totalFilters: number;
  hideTitle?: boolean;
}

export function FilterSkeleton({ control, index, totalFilters, hideTitle }: FilterSkeletonProps) {
  return (
    <div key={control.id} className={cn('flex flex-col gap-2', hideTitle && 'mt-2')}>
      {(control.type === 'date' || control.type === 'date-range') && (
        <div className='h-8 animate-pulse rounded-sm bg-muted' />
      )}

      {control.type === 'multi-select' && (
        // eslint-disable-next-line noddi/enforce-spacing-scale -- not migrated yet: legacy space-y-2 stack, equals flex flex-col gap-2
        <div className='space-y-2'>
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className='flex gap-2'>
              <div className='size-4 animate-pulse rounded-sm bg-muted' />
              <div className='h-4 w-full animate-pulse rounded-sm bg-muted' />
            </div>
          ))}
        </div>
      )}

      {control.type === 'single-select' && (
        <div className='flex flex-col gap-1'>
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className='flex gap-2'>
              <div className='size-4 animate-pulse rounded-full bg-muted' />
              <div className='h-4 w-full animate-pulse rounded-sm bg-muted' />
            </div>
          ))}
        </div>
      )}

      {control.type === 'boolean' && (
        <div className='flex items-center justify-between'>
          <div className='h-5 w-3/5 animate-pulse rounded-sm bg-muted' />
          <div className='h-5 w-10 animate-pulse rounded-full bg-muted' />
        </div>
      )}

      {index < totalFilters - 1 && <NoddiSeparator className='mt-4' />}
    </div>
  );
}
